document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".accordion").forEach(function(accordion) {
    var span = accordion.querySelector(".details__summary span");
    if (span) {
      var text = span.textContent.replace(/\u00A0/g, "").trim(); // remove &nbsp; and spaces
      if (text === "") {
        accordion.style.display = "none";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewLink = document.querySelector('a[href="#judgeme_product_reviews"]');
  if (!reviewLink) return;
  // Function to toggle visibility
  function toggleLink() {
    if (document.querySelector(".jdgm-rev-widg__summary-average")) {
      reviewLink.style.display = ""; // Show if average summary exists
    } else {
      reviewLink.style.display = "none"; // Hide otherwise
    }
  }
  // Run once on load
  toggleLink();
  // Watch for changes in the DOM (for when reviews load in)
  const observer = new MutationObserver(toggleLink);
  observer.observe(document.body, { childList: true, subtree: true });
});

